import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isActive: boolean
}

export const ButtonTab = styled(ButtonPlain)<Props>`
	position: relative;
	padding: 6px 12px;
	border-top: ${({ isActive }) => (isActive ? 3 : 1)}px solid ${({ isActive }) => (isActive ? helpers.color.primaryAccent : helpers.color.border)};
	border-bottom: 1px solid ${({ isActive }) => (isActive ? 'transparent' : helpers.color.border)};
	background-color: ${({ isActive }) => (isActive ? helpers.color.codeBlockBackground : helpers.color.background)};
	border-right: 1px solid ${helpers.color.border};
	min-width: fit-content;
	height: 37px;
	transition: background-color 0.1s, color 0.1s;

	&:first-of-type {
		border-left: 1px solid ${helpers.color.border};
		border-top-left-radius: 4px;
	}

	&:last-of-type {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		border-right: ${({ isActive }) => (isActive ? 'none' : `1px solid ${helpers.color.border}`)};

		&:after {
			content: '';
			position: absolute;
			background-color: ${({ isActive }) => (isActive ? helpers.color.border : 'transparent')};
			top: 0px;
			right: 0px;
			height: 50%;
			width: 1px;
		}
	}

	&:hover:not(:disabled) {
		background-color: ${helpers.color.primaryLightened};
		color: ${helpers.color.primary};
	}

	&:disabled {
		user-select: text;
	}
`
